import { PageTemplate } from "features/users/templates";
import { employeesTemplateConfig } from "../config";

export const Employees = () => {
  return <PageTemplate template={employeesTemplateConfig} />;
};
